import React from 'react'

const Tennis = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 24 22' version='1.1'>
      <title>Tennis</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fillRule='evenodd'>
        <g id='Desktop-10' transform='translate(-506.000000, -426.000000)' fillRule='nonzero'>
          <g id='Sports-Selection' transform='translate(465.000000, 299.000000)'>
            <g id='onboarding/sport-copy-12' transform='translate(0.000000, 102.000000)'>
              <g id='icon/16/sport/tennis/tennis-racket' transform='translate(41.000000, 24.089286)'>
                <path
                  d='M3.945,11.8840925 C2.18045022,11.8840925 0.75,10.4536422 0.75,8.68909246 C0.75,6.92454268 2.18045022,5.49409246 3.945,5.49409246 C5.70954978,5.49409246 7.14,6.92454268 7.14,8.68909246 C7.14,9.53645914 6.8033849,10.3491199 6.20420617,10.9482986 C5.60502744,11.5474774 4.79236669,11.8840925 3.945,11.8840925 Z M20.535,13.2490925 C18.7396459,15.1441291 16.1746308,16.1115378 13.575,15.8740925 C11.445,15.5290925 10.575,15.8740925 9.825,16.6240925 L3.615,22.8340925 L1.92,21.1390925 L8.13,15.0040925 C8.925,14.2090925 9.225,13.3840925 8.88,11.2390925 C8.62122978,8.6189213 9.59056779,6.0266345 11.505,4.21909246 C14.625,1.09909246 19.185,0.589092459 21.75,3.07909246 C24.315,5.56909246 23.655,10.1290925 20.535,13.2490925 L20.535,13.2490925 Z M19.98,4.77409246 C18.48,3.27409246 15.39,3.72409246 13.2,5.89909246 C11.01,8.07409246 10.515,11.1190925 12.075,12.6790925 C13.635,14.2390925 16.665,13.7290925 18.855,11.5540925 C21.045,9.37909246 21.54,6.33409246 19.98,4.77409246 L19.98,4.77409246 Z'
                  id='path'
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Tennis
